export type DialogModeTypes = 'ADD' | 'EDIT';
